import React, { useEffect, useRef } from 'react';
import tippy from 'tippy.js';

// TODO replace this component with Material UI tooltip

const Tooltip = ({ children, content, delay, ...rest }) => {
  const nodeRef = useRef(null);
  const instanceRef = useRef(null);
  const contentRef = useRef(content);
  const hasContent = !!content;

  useEffect(() => {
    contentRef.current = content;
  }, [content]);

  useEffect(() => {
    if (!nodeRef.current || !hasContent) return undefined;
    const instance = tippy(nodeRef.current, {
      content: contentRef.current,
      allowHTML: true,
      delay,
    });
    instanceRef.current = instance;
    return () => {
      instance.destroy();
      if (instanceRef.current === instance) {
        instanceRef.current = null;
      }
    };
  }, [delay, hasContent]);

  useEffect(() => {
    if (instanceRef.current && content) {
      instanceRef.current.setContent(content);
    }
  }, [content]);

  return (
    <span ref={nodeRef} {...rest}>
      {children}
    </span>
  );
};

export default Tooltip;
